import React from "react";

const Loading = ({ loading, currentColor }) => {
  return (
    <div className="fixed top-0 left-0 z-50 w-full h-full flex flex-col items-center justify-center bg-gray-900 bg-opacity-50">
      <div
        className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2"
        style={{
          borderTopColor: currentColor,
          borderBottomColor: currentColor,
        }}
      ></div>
      <p className="mt-4 text-white">{loading}...</p>
    </div>
  );
};

export default Loading;
